import { GetIncidenciasQuery } from "src/gql/schema"
import { IncidenciaRow } from "../Incidencia.types"
import { capitalizeString } from "src/shared/hooks/capitalizeString"


function buildTable(
    data: GetIncidenciasQuery["incidencias"],
    formatDate: (fecha: Date | string | number | null | undefined, mask: string) => string
) {


    const array: IncidenciaRow[] = []
    data?.map((incidencia) => {
        array.push({
            goTo: incidencia?.incidencia_id,
            value: [
                { value: incidencia?.folio + "" },
                { value: capitalizeString(incidencia?.estado || "") || "" },
                {
                    value: formatDate(
                        incidencia?.fecha_registro,
                        "DD/MMM/YYYY hh:mm A"
                    ),
                },

                {
                    value: `${incidencia?.area ? capitalizeString(incidencia?.area) : "N/A"}`,
                },
                {
                    value: capitalizeString(incidencia?.tipo_incidencia || "N/A"),
                },
                {
                    value: incidencia?.habitacion?.numero_habitacion || "N/A",
                },
                { value: incidencia?.matricula || "-" },
                { value: incidencia?.detalle || "-" },
                { value: capitalizeString(incidencia?.severidad) },
            ],
        })
    })
    return array
}

export default buildTable
